<template>
  <div
    class="absolute_center"
    style="width: 1620px;overflow-y: scroll"
    :class="{
      _boxBg_green_secondLevel: styleType == 'typeGreen',
      _boxBg_dark_secondLevel: styleType == 'typeDark',
      _boxBg_blue_secondLevel: styleType == 'typeBlue',
      _boxBg_strong_secondLevel: styleType == 'typeStrong'
    }"
  >
    <div class="selfClose_btn" style="top: 10px" @click="close"></div>
    <div class="_boxTitle">{{title}}</div>
    <div class="_yellowLine"></div>
    <div class="_innerBox">
      <div class="page1" v-show="detailShow">
        <div class="check_box">
          <el-form
            :inline="true"
            class="demo-form-inline secondLevel-form-inline"
          >
            <el-form-item class="secondLevel-label" label="环保登记编码：">
              <el-input
                class="secondLevel-input"
                v-model="params.keyword"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="排放阶段：" class="secondLevel-label">
              <el-select
                class="secondLevel-select"
                v-model="params.vehicleEmissions"
                placeholder="请选择"
              >
                <el-option label="全部" :value="''"></el-option>
                <el-option label="国I" :value="1"></el-option>
                <el-option label="国II" :value="2"></el-option>
                <el-option label="国III" :value="3"></el-option>
                <el-option label="国IV" :value="4"></el-option>
                <el-option label="国V" :value="5"></el-option>
                <el-option label="国VI" :value="6"></el-option>
                <el-option label="新能源" :value="99"></el-option>
                <el-option v-if="electricVehicle" label="纯电" :value="199"></el-option>
                <!-- <el-option label="铁路运输" :value="101"></el-option>
              <el-option label="水路运输" :value="102"></el-option>
              <el-option label="管道或管状带式输送机" :value="103"></el-option>-->
              </el-select>
            </el-form-item>
            <el-form-item style="margin-top: -1px;vertical-align: middle;margin-bottom: 0" label=" ">
              <a class="self_btn" @click="handleCurrentChange(1)">查询</a>
              <a class="self_btn" @click="reset()">重置</a>
            </el-form-item>
          </el-form>
        </div>
        <div class="table_box" style="height: 640px">
          <el-table
            :data="dataList"
            style="width: 100%"
            @row-click="rowClick"
            :header-cell-class-name="'thClass'"
            :header-row-class-name="'headTrClass'"
            :cell-class-name="'tdClass'"
            :row-class-name="'trClass'"
            class="secondLevel_table"
          >
            <el-table-column
              prop="environmentCode"
              label="环保登记编码"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="customerId == 22"
              prop="mechanicalEnvironment"
              label="机械环保代码\环保信息公开编码"
              align="center"
              width="310"
            ></el-table-column>
            <el-table-column
              v-if="customerId !== 22 && newAccessType"
              prop="mechanicalEnvironment"
              label="机械环保代码"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="customerId !== 22 && customerId !== 47"
              prop="environmentSn"
              label="环保信息公开编码"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="productionDate"
              label="生产日期"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="vehicleEmissions"
              label="排放阶段"
              align="center"
            >
              <template #default="scope">{{
                vehicleMissionsName[scope.row.vehicleEmissions]
              }}</template>
            </el-table-column>
<!--            <el-table-column label="发动机铭牌" align="center">
              <template>
                <span
                  class="view"
                  style="cursor: pointer; color: rgb(0, 252, 255)"
                  >查看</span
                >
              </template>
            </el-table-column>-->
            <!-- <el-table-column v-if="customerId==22" prop="openCode" label="公开编码" align="center"></el-table-column> -->
            <el-table-column
              v-if="customerId !== 47"
              prop="fuelType"
              label="燃料类型"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="newAccessType && customerId !== 47"
              prop="machineType"
              label="机械种类"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="!newAccessType && customerId !== 47 && customerId !== 11"
              prop="mechanicalType"
              label="机械种类"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="!newAccessType && customerId == 11"
              prop="machineType"
              label="机械种类"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="customerId !== 47"
              prop="engineType"
              label="发动机型号"
              align="center"
            ></el-table-column>
            <el-table-column  label="详情" align="center">
              <template #default="scope">
                <span class="view" style="cursor:pointer;color:rgb(0, 252, 255)">查看</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page_box">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="params.pageNo"
            :page-size="params.pageSize"
            layout="total,prev, pager, next, jumper"
            :total="page_total"
          >
          </el-pagination>
          <p>跳转</p>
        </div>
      </div>
      <div class="page2" v-show="!detailShow">
        <div
          class="selfReturn_btn"
          style="top: 10px"
          @click="returnClick"
        ></div>
        <div class="main-title" v-if="newAccessType">
          非道路移动机械信息
        </div>
        <div class="account">

          <door-title style="margin-bottom: 20px" v-if="newAccessType">机械基础信息</door-title>
          <div class="basic-info">
            <div class="basic-item">
              <label class="item-label">环保登记编码：</label>
              <span>{{ info && info.environmentCode }}</span>
            </div>

             <div class="basic-item" v-if="newAccessType">
              <label class="item-label">环保信息公开编码：</label>
              <span>{{info?.environmentSn}}</span>
            </div>
            <div class="basic-item" v-if="!newAccessType">
              <label class="item-label">车队名称：</label>
              <span>所有人</span>
            </div>
            <div class="basic-item" v-if="newAccessType">
              <label class="item-label">所属单位：</label>
              <span>{{ info?.owener }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">生产日期：</label>
              <span>{{ info && info.productionDate }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">排放阶段：</label>
              <span>{{
                vehicleMissionsName[info && info.vehicleEmissions]
              }}</span>
            </div>
            <div class="basic-item" v-if="newAccessType">
              <label class="item-label">机械型号：</label>
              <span>{{ info?.mechanicalModel }}</span>
            </div>
            <div class="basic-item" v-if="customerId == 22 || newAccessType">
              <label class="item-label">机械种类：</label>
              <span v-if="customerId == 22">{{ info?.mechanicalType }}</span>
              <span v-if="newAccessType">{{ info?.machineType }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">{{
                customerId != 22
                  ? "机械环保代码："
                  : "机械环保代码\环保信息公开编码："
              }}</label>
              <span>{{ info && info.mechanicalEnvironment }}</span>
            </div>
            <div class="basic-item" v-if="newAccessType">
              <label class="item-label">发动机型号：</label>
              <span>{{ info?.engineType }}</span>
            </div>
            <div class="basic-item" v-if="newAccessType">
              <label class="item-label">发动机编号：</label>
              <span>{{ info?.engineModel }}</span>
            </div>
            <div class="basic-item" v-if="newAccessType">
              <label class="item-label">发动机生产厂：</label>
              <span>{{ info?.engineVendor }}</span>
            </div>
            <div class="basic-item" v-if="customerId == 22 || newAccessType">
              <label class="item-label">燃料类型：</label>
              <span>{{ info?.fuelType }}</span>
            </div>
            <div class="basic-item" v-if="newAccessType">
              <label class="item-label">车牌号码：</label>
              <span>{{ info?.numberPlate }}</span>
            </div>
          </div>
          <door-title v-if="newAccessType">机械图片</door-title>
          <div class="picture-info">
            <div class="picture-inner" v-if="newAccessType && customerId != 50" @click="picture_click(info.environmentLabelImage)">
              <div class="picture">
                <img
                  v-if="info && (info.environmentLabelImage)"
                  :src="info && (info.environmentLabelImage)"
                />
                <img v-else src="./img/no_img.png" />
                <span>机械环保标签铭牌照片</span>
              </div>
            </div>
            <div class="picture-inner" @click="picture_click(info.engineImage)">
              <div class="picture">
                <img
                  v-if="info && info.engineImage"
                  :src="info && info.engineImage"
                />
                <img v-else src="./img/no_img.png" />
                <span>发动机铭牌</span>
              </div>
            </div>
            <div
              class="picture-inner label-photo"
              v-if="customerId != 50"
              @click="picture_click(info?.deviceImage)"
            >
              <div class="picture">
                <img v-if="info?.deviceImage" :src="info?.deviceImage" />
                <img v-else src="./img/no_img.png" />
                <span v-if="newAccessType">整车铭牌</span>
                <span v-else>设备铭牌</span>
              </div>
            </div>
               <div class="picture-inner" @click="picture_click(info.vehicleLable)">
              <div class="picture">
                <img
                  v-if="info && info.vehicleLable"
                  :src="info && info.vehicleLable"
                />
                <img v-else src="./img/no_img.png" />
                <span>环保信息标签图片</span>
              </div>
            </div>
            <div
              v-if="customerId == 22"
              class="picture-inner label-photo"
              @click="picture_click(info?.labelPhoto)"
            >
              <div class="picture">
                <img v-if="info?.labelPhoto" :src="info?.labelPhoto" />
                <img v-else src="./img/no_img.png" />
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import imgBox from "./components/imgBox.vue";
import doorTitle from "modules/cleanTransportComponents/components/doorTitle/doorTitle";
export default {
  name: "accountListNonmove",
  title: "详细信息",
  props: ["globalInstance"],
  setup(props) {
    const globalInstance = props.globalInstance;
    return { globalInstance };
  },
  components: {
    doorTitle
  },
  data() {
    return {
      electricVehicle: bmeConfig.electricVehicle,
      pageInfo: 'accountListNonmove.vue',
      computedName: '非道路移动机械电子台账组件',
      isPublicCleanTransport: bmeConfig.isPublicCleanTransport,
      title: '非道路移动机械电子台账',
      newAccessType: this.$store.state.newAccessType,
      styleType: "",
      detailShow: true,
      vehicleMissionsName: {
        1: "国I",
        2: "国II",
        3: "国III",
        4: "国IV",
        5: "国V",
        6: "国VI",
        99: "新能源",
        // 101: "铁路运输",
        // 102: "水路运输",
        // 103: "管道或管状带式输送机",
      },
      params: {
        keyword: "",
        vehicleEmissions: "",
        pageNo: 1,
        pageSize: 10,
        customerId: this.$store.state.customerId,
      },
      page_total: 0,
      dataList: [],
      info: [],
      customerId: this.$store.state.customerId,
    };
  },
  computed: {
    ...mapGetters({
      dialogCompontent2: "getDialogCompontent2",
    }),
    curStyleTypeVal() {
      return this.globalInstance.$store.state.styleType;
    },
  },
  created() {
    this.styleType = this.globalInstance.$store.state.styleType;
  },
  mounted() {
    if (this.electricVehicle) {
      this.vehicleMissionsName['199'] = '纯电';
    }
    this.getCarListNonMovement();
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
  },
  methods: {
    async getCarListNonMovement() {
      let url = this.globalInstance.cleanTransportIp + "/no_road/list";
      let res = await this.globalInstance.$apiUtils.get3(url, this.params);
      this.dataList = res.list;
      this.page_total = res.rowCount;
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getCarListNonMovement();
    },
    reset() {
      this.params.pageNo = 1;
      this.params.keyword = "";
      this.params.vehicleEmissions = "";
      this.getCarListNonMovement();
    },
    rowClick(row) {
      this.detailShow = false;
      // this.info = row;
      this.getCarDetailNonMovement(row.environmentCode);
      if (this.newAccessType) {
        this.title = '非道路移动机械信息';
      }
    },
    async getCarDetailNonMovement(number) {
      let url = this.globalInstance.cleanTransportIp + "/no_road/detail";
      let res = await this.globalInstance.$apiUtils.get3(url, {
        environmentCode: number,
        customerId:this.customerId,
      });
      this.info = res;
    },
    returnClick() {
      this.detailShow = true;
      this.title = '非道路移动机械电子台账';
    },
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
    },
    picture_click(url) {
      if (!url) return;
      this.globalInstance.$store.commit("dialogStatus2", true);
      this.globalInstance.$popup.open2(imgBox, this.dialogCompontent2, this, {
        imgurl: url,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main-title {
  text-align: center;
  font-size: 25px;
}
.account {
  width: 100%;
  height: 100%;
  padding: 70px 80px;
  font-size: 20px;
  .door-title {
    margin-left: -25px;
    font-size: 24px;
  }
  .basic-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .basic-item {
      width: 33.3%;
      height: 60px;
      line-height: 30px;
      color: white;
      margin-bottom:30px;
      .item-label {
        color: #a2d8ff;
      }
    }
  }
  .picture-info {
    margin-top: 140px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .picture-inner {
      width: 49%;
      margin-bottom: 25px;
      p {
        color: #a2d8ff;
        font-size: 22px;
        line-height: 130px;
        text-align: center;
      }
      .picture {
        padding: 10px;
        width: 100%;
        height: 340px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        // background-image: url("../img/img_bg.png");
        position: relative;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        span {
          font-weight: bold;
          color: #d7d7d7;
          font-size: 24px;
        }
        img {
          width: 100%;
          height: 100%;
        }
        &:before {
          content: "";
          position: absolute;
          top: 20px;
          right: 20px;
          width: 54px;
          height: 54px;
          // background-image: url("./../img/enlarge.png");
        }
      }
    }
    .label-photo {
      margin-left: 10px;
    }
  }
}
.page_box {
  margin-top: 20px;
  :deep(.el-pagination) {
      --el-pagination-font-size: 24px;
    }
  :deep(.el-icon-arrow-left) {
    margin: 0 auto;
  }
  :deep(.el-icon-arrow-right) {
    margin: 0 auto;
  }
}
</style>
